import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import AccountCreatedDisplay from './AccountCreatedDisplay';

class AccountCreatedContainer extends React.Component {
  static propTypes = {
    createAccount: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    createAccountStatus: PropTypes.object
  };

  static defaultProps = {
    createAccountStatus: { posting: false }
  }

  state = {
    submitting: false,
    formValue: {
      isProducer: true,
      fbpn: '',
      homeState: '',
      isUnverifiedFbpn: false,
      accountNumber: '',
      accountName: '',
    }
  }

  componentDidUpdate(prevProps) {
    const { posting, error } = this.props.createAccountStatus;
    if (this.state.submitting && !posting && !error && prevProps.createAccountStatus.posting !== posting) {
      this.props.history.push('/');
    }
  }

  handleNewItem = (newValue) => {
    this.setState(state => ({ formValue: Object.assign({ ...state.formValue }, { isUnverifiedFbpn: newValue }) }));
  };

  handleChange = (newValue) => {
    this.setState({ formValue: { ...newValue } });
  }

  onSubmit = () => {
    const {
      formValue: {
        isProducer,
        homeState,
        isUnverifiedFbpn,
        fbpn,
        accountNumber,
        accountName
      }
    } = this.state;

    const fbpnValue = isProducer ? fbpn.fbpn : fbpn;

    const account = {
      accountName,
      isProducer,
      fbpn: fbpnValue,
      homeState,
      isUnverifiedFbpn,
      carrierAccounts: [accountNumber],
    };

    this.setState({ submitting: true });
    this.props.createAccount(account);
  }

  render() {
    return (
      <AccountCreatedDisplay
        submitting={ this.props.createAccountStatus.posting }
        value={ this.state.formValue }
        onChange={ this.handleChange }
        onSubmit={ this.onSubmit }
        onNewFbpn={ this.handleNewItem }
      />
    );
  }
}

export default withRouter(AccountCreatedContainer);
